module.exports = __webpack_public_path__ + "static/media/boat_shrunk.e5d4f383.mp4";